module.exports = __webpack_public_path__ + "img/border.3a48184.png";